export default __webpack_public_path__ + "static/media/InfoImage.9ae8da96.svg";